// extracted by mini-css-extract-plugin
module.exports = {"caption":"_2p0n0ZwL6y6iDPvTWMFSRx"};